/*!
 * @oarepo/invenio-oarepo-ui-vue v1.9.0
 * (c) Miroslav Bauer <bauer@cesnet.cz>
 * Released under the MIT License.
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';
import { Emit, Watch } from 'vue-property-decorator';
import { Module, Mutation, Action, VuexModule } from 'vuex-class-modules';
import axios from 'axios';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }

  return desc;
}

var _dec, _class;
var OARepoCollectionList = (_dec = Component({}), _dec(_class =
/*#__PURE__*/
function (_Vue) {
  _inherits(OARepoCollectionList, _Vue);

  function OARepoCollectionList() {
    _classCallCheck(this, OARepoCollectionList);

    return _possibleConstructorReturn(this, _getPrototypeOf(OARepoCollectionList).apply(this, arguments));
  }

  _createClass(OARepoCollectionList, [{
    key: "mounted",
    value: function mounted() {
      this.oarepo$.collectionListModule.loadCollections();
    }
  }, {
    key: "collections",
    // getters
    get: function get() {
      return this.oarepo$.collectionListModule.collections;
    }
  }]);

  return OARepoCollectionList;
}(Vue)) || _class);

/* script */
var __vue_script__ = OARepoCollectionList;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm._t("default", [_c('router-view')], {
    "collections": _vm.collections
  })], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

var OARepoCollectionList$1 = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

var _dec$1, _class$1;
var OARepoFacetList = (_dec$1 = Component({
  name: 'oarepo-facet-list',
  props: {
    facets: Object
  }
}), _dec$1(_class$1 =
/*#__PURE__*/
function (_Vue) {
  _inherits(OARepoFacetList, _Vue);

  function OARepoFacetList() {
    _classCallCheck(this, OARepoFacetList);

    return _possibleConstructorReturn(this, _getPrototypeOf(OARepoFacetList).apply(this, arguments));
  }

  _createClass(OARepoFacetList, [{
    key: "facetSelected",
    value: function facetSelected(bucketP, selected) {
      var bucket = bucketP;

      if (selected) {
        this.oarepo$.collectionModule.facetSelected({
          facet: bucket.facet,
          key: bucket.key,
          bucket: bucket
        });
      } else {
        this.oarepo$.collectionModule.facetDeselected({
          facet: bucket.facet,
          key: bucket.key,
          bucket: bucket
        });
      }
    }
  }, {
    key: "visibleFacets",
    get: function get() {
      var _this = this;

      return Object.keys(this.facets).reduce(function (visibleFacets, testedFacet) {
        if (_this.facets[testedFacet].facetShown) {
          visibleFacets[testedFacet] = _this.facets[testedFacet];
        }

        return visibleFacets;
      }, {});
    }
  }]);

  return OARepoFacetList;
}(Vue)) || _class$1);

/* script */
var __vue_script__$1 = OARepoFacetList;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm._t("default", null, {
    "facets": _vm.visibleFacets
  })], 2);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

var OARepoFacetList$1 = __vue_normalize__({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, undefined, undefined);

var _dec$2, _dec2, _dec3, _dec4, _class$2, _class2;
var OARepoCollection = (_dec$2 = Component({
  props: {
    collectionCode: String,
    locale: String
  },
  components: {
    'oarepo-facet-list': OARepoFacetList$1
  },
  name: 'oarepo-collection'
}), _dec2 = Emit('dataLoaded'), _dec3 = Watch('locale'), _dec4 = Watch('$route'), _dec$2(_class$2 = (_class2 =
/*#__PURE__*/
function (_Vue) {
  _inherits(OARepoCollection, _Vue);

  function OARepoCollection() {
    _classCallCheck(this, OARepoCollection);

    return _possibleConstructorReturn(this, _getPrototypeOf(OARepoCollection).apply(this, arguments));
  }

  _createClass(OARepoCollection, [{
    key: "reloadData",
    value: function reloadData() {
      var _this = this;

      console.log('Loading', this.collectionCode);
      return new Promise(function (resolve) {
        _this.oarepo$.collectionModule.collectionListModule.loadCollections().then(function () {
          _this.oarepo$.collectionModule.search({
            collectionDefinition: _this.collection,
            params: _this.$route.query
          }).then(function (_ref) {
            var append = _ref.append;
            resolve({
              append: append
            });
          });
        });
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.reloadData();
    }
  }, {
    key: "onLocaleChanged",
    value: function onLocaleChanged(locale) {
      this.oarepo$.collectionModule.changeLocale(locale);
    }
  }, {
    key: "onQueryChanged",
    value: function onQueryChanged() {
      this.reloadData();
    }
  }, {
    key: "loaded",
    // getters
    get: function get() {
      return this.oarepo$.collectionModule.collectionListModule.loaded && this.collectionCode;
    }
  }, {
    key: "collection",
    get: function get() {
      var _this2 = this;

      console.log('collection returning', this.collectionCode, this.oarepo$.collectionModule.collectionListModule.collections, this.oarepo$.collectionModule.collectionListModule.collections.find(function (value) {
        return value.code === _this2.collectionCode;
      }));
      return this.oarepo$.collectionModule.collectionListModule.collections.find(function (value) {
        return value.code === _this2.collectionCode;
      });
    }
  }, {
    key: "aggregations",
    get: function get() {
      return this.oarepo$.collectionModule.aggregations;
    }
  }, {
    key: "items",
    get: function get() {
      return this.oarepo$.collectionModule.items;
    }
  }]);

  return OARepoCollection;
}(Vue), (_applyDecoratedDescriptor(_class2.prototype, "reloadData", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "reloadData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onLocaleChanged", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "onLocaleChanged"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onQueryChanged", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "onQueryChanged"), _class2.prototype)), _class2)) || _class$2);

/* script */
var __vue_script__$2 = OARepoCollection;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.loaded ? _c('div', {
    staticClass: "container"
  }, [_vm._t("default", [_c('router-view')], {
    "items": _vm.items,
    "aggregations": _vm.aggregations,
    "collection": _vm.collection
  })], 2) : _vm._e();
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

var OARepoCollection$1 = __vue_normalize__({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, undefined, undefined);

var Query =
/*#__PURE__*/
function () {
  function Query(queryDict) {
    _classCallCheck(this, Query);

    this.query = Object.assign({}, queryDict || {});
  }

  _createClass(Query, [{
    key: "set",
    value: function set(key, value) {
      var stringValue = value.toString();
      var prev = this.query[key];

      if (prev === undefined) {
        this.query[key] = [];
      } else if (!Array.isArray(this.query[key])) {
        this.query[key] = [this.query[key]];
      } else {
        this.query[key] = this.query[key].slice();
      }

      this.query[key] = this.query[key].filter(function (x) {
        return x !== stringValue;
      });
      this.query[key].push(stringValue);
    }
  }, {
    key: "remove",
    value: function remove(key, value) {
      var stringValue = value.toString();
      var prev = this.query[key];

      if (prev === undefined) {
        return;
      }

      if (!Array.isArray(this.query[key])) {
        this.query[key] = [this.query[key]];
      } else {
        this.query[key] = this.query[key].slice();
      }

      this.query[key] = this.query[key].filter(function (x) {
        return x !== stringValue;
      });

      if (this.query[key].length === 0) {
        delete this.query[key];
      }
    }
  }, {
    key: "removeKey",
    value: function removeKey(key) {
      if (this.query[key] !== undefined) {
        delete this.query[key];
      }
    }
  }, {
    key: "replace",
    value: function replace(key, value) {
      this.removeKey(key);
      this.set(key, value);
    }
  }, {
    key: "has",
    value: function has(key, value) {
      var stringValue = value.toString();
      var prev = this.query[key];

      if (prev === undefined) {
        return false;
      }

      if (!Array.isArray(this.query[key])) {
        this.query[key] = [this.query[key]];
      }

      return this.query[key].filter(function (x) {
        return x === stringValue;
      }).length > 0;
    }
  }, {
    key: "get",
    value: function get(key) {
      var singleValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var val = this.query[key];

      if (val === undefined || val === []) {
        return singleValue ? undefined : [];
      }

      if (!Array.isArray(this.query[key])) {
        return singleValue ? val : [val];
      }

      return singleValue ? val[0] : val;
    }
  }]);

  return Query;
}();

var _class$3, _class2$1, _temp, _class4, _class5, _temp2, _class7, _class8, _temp3;
var State = {
  INVALID: 0,
  LOADING: 1,
  LOADED: 2
};

var CollectionListModule = Module(_class$3 = (_class2$1 = (_temp =
/*#__PURE__*/
function (_VuexModule) {
  _inherits(CollectionListModule, _VuexModule);

  function CollectionListModule() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CollectionListModule);

    for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CollectionListModule)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.collections = [];
    _this.state = State.INVALID;
    _this.apiURL = null;
    return _this;
  }

  _createClass(CollectionListModule, [{
    key: "setCollections",
    value: function setCollections(collections) {
      this.collections = collections;
    }
  }, {
    key: "setApiURL",
    value: function setApiURL(apiURL) {
      this.apiURL = apiURL;
    }
  }, {
    key: "setState",
    value: function setState(state) {
      this.state = state;
    }
  }, {
    key: "loadCollections",
    value: async function loadCollections() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.loaded && !force) {
        return this.collections;
      }

      this.setState(State.LOADING);
      var response = await axios.get("".concat(this.apiURL, "collections"));
      this.setCollections(response.data);
      this.setState(State.LOADED);
      return response.data;
    }
  }, {
    key: "loaded",
    get: function get() {
      return this.state === State.LOADED;
    }
  }, {
    key: "visibleCollections",
    get: function get() {
      if (this.state !== State.LOADED) {
        return [];
      }

      return this.collections.filter(function (x) {
        return !x.hidden;
      });
    }
  }]);

  return CollectionListModule;
}(VuexModule), _temp), (_applyDecoratedDescriptor(_class2$1.prototype, "setCollections", [Mutation], Object.getOwnPropertyDescriptor(_class2$1.prototype, "setCollections"), _class2$1.prototype), _applyDecoratedDescriptor(_class2$1.prototype, "setApiURL", [Mutation], Object.getOwnPropertyDescriptor(_class2$1.prototype, "setApiURL"), _class2$1.prototype), _applyDecoratedDescriptor(_class2$1.prototype, "setState", [Mutation], Object.getOwnPropertyDescriptor(_class2$1.prototype, "setState"), _class2$1.prototype), _applyDecoratedDescriptor(_class2$1.prototype, "loadCollections", [Action], Object.getOwnPropertyDescriptor(_class2$1.prototype, "loadCollections"), _class2$1.prototype)), _class2$1)) || _class$3;

var CollectionModule = Module(_class4 = (_class5 = (_temp2 =
/*#__PURE__*/
function (_VuexModule2) {
  _inherits(CollectionModule, _VuexModule2);

  function CollectionModule() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, CollectionModule);

    for (var _len2 = arguments.length, args = new Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(CollectionModule)).call.apply(_getPrototypeOf3, [this].concat(args)));
    _this2.collectionDefinition = {};
    _this2.valueTranslator = null;
    _this2.state = State.INVALID;
    _this2.aggregations = {};
    _this2.items = [];
    _this2.queryParams = {};
    _this2.collectionListModule = null;
    _this2.facetHandler = null;
    _this2.totalPages = 0;
    return _this2;
  }

  _createClass(CollectionModule, [{
    key: "setFacetHandler",
    value: function setFacetHandler(facetHandler) {
      this.facetHandler = facetHandler;
    }
  }, {
    key: "setState",
    value: function setState(state) {
      this.state = state;
    }
  }, {
    key: "setCollectionListModule",
    value: function setCollectionListModule(collectionListModule) {
      this.collectionListModule = collectionListModule;
    }
  }, {
    key: "setCollectionDefinition",
    value: function setCollectionDefinition(collectionDefinition) {
      this.collectionDefinition = collectionDefinition;
    }
  }, {
    key: "setValueTranslator",
    value: function setValueTranslator(valueTranslator) {
      this.valueTranslator = valueTranslator;
    }
  }, {
    key: "setQueryParams",
    value: function setQueryParams(queryParams) {
      // make duplicate
      this.queryParams = Object.assign({}, queryParams);
    }
  }, {
    key: "flatten",
    value: function flatten(aggregations, queryParams) {
      var _this3 = this;

      var valueTranslator = this.valueTranslator || function (x) {
        return x;
      };

      var flattenedAggregations = {};
      Object.entries(aggregations).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        var value = val;
        var facetShown = !(_this3.callFacetHandler('showFacet', key, value) === false);

        if (key !== 'doc_count' && value !== null) {
          if (value.buckets !== undefined) {
            value.label = valueTranslator(key, {
              type: 'facet'
            });
            value.buckets.forEach(function (x) {
              var bucket = x;
              bucket.facet = key;
              bucket.label = valueTranslator(x.key, {
                type: 'bucket',
                facet: key,
                bucket: bucket
              });

              var _key = _this3.callFacetHandler('facetKey', key, bucket.key, bucket) || bucket.key;

              bucket.selected = queryParams.has(key, _key);
            });
            value.facetShown = facetShown;
            flattenedAggregations[key] = value;
          } else {
            // NOTE: This is needed for numeric aggregations
            if ('value' in value && Number.isInteger(value['value'])) {
              value.facetShown = facetShown;
              flattenedAggregations[key] = value;
            } else {
              Object.assign(flattenedAggregations, _this3.flatten(value, queryParams));
            }
          }
        }
      });
      return flattenedAggregations;
    }
  }, {
    key: "setSearchResults",
    value: function setSearchResults(_ref3) {
      var aggregations = _ref3.aggregations,
          items = _ref3.items,
          total = _ref3.total;
      var q = new Query(this.queryParams);
      this.aggregations = this.flatten(aggregations, q);
      this.items = items;
      var pageSize = this.queryParams.size || 10;
      this.totalPages = Math.ceil(total / pageSize);
    }
  }, {
    key: "search",
    value: async function search(_ref4) {
      var collectionDefinition = _ref4.collectionDefinition,
          params = _ref4.params,
          force = _ref4.force;
      // duplicate params
      var queryParams = params || {};

      if (this.loaded && this.collectionDefinition.code === collectionDefinition.code && this.queryParams === queryParams && !force) {
        return undefined; // already loaded
      }

      this.setCollectionDefinition(collectionDefinition);
      this.setQueryParams(queryParams);
      this.setState(State.LOADING); // convert to http params

      var axiosParams = new URLSearchParams();
      Object.entries(queryParams).forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            pkey = _ref6[0],
            pvalue = _ref6[1];

        if (Array.isArray(pvalue)) {
          pvalue.forEach(function (val) {
            axiosParams.append(pkey, val);
          });
        } else {
          axiosParams.append(pkey, pvalue);
        }
      });
      var response = await axios.get("".concat(this.restSearchUrl), {
        params: axiosParams
      });
      var _response$data = response.data,
          aggregations = _response$data.aggregations,
          hits = _response$data.hits;
      this.setSearchResults({
        aggregations: aggregations,
        items: hits.hits,
        total: hits.total
      });
      this.setState(State.LOADED);
      return {
        response: response.data
      };
    }
  }, {
    key: "changeLocale",
    value: function changeLocale() {
      this.setSearchResults({
        aggregations: this.aggregations,
        items: this.items
      });
    }
  }, {
    key: "setPage",
    value: async function setPage(page) {
      return this.search({
        collectionDefinition: this.collectionDefinition,
        params: Object.assign({}, this.queryParams, {
          page: page
        }),
        force: false,
        append: false
      });
    }
  }, {
    key: "getRouter",
    value: function getRouter() {
      var router = this.callFacetHandler('getRouter');

      if (!router) {
        throw new Error('Please set up getRouter method on facetHandler');
      }

      return router;
    }
  }, {
    key: "facetSelected",
    value: async function facetSelected(_ref7) {
      var facet = _ref7.facet,
          key = _ref7.key,
          bucket = _ref7.bucket,
          replace = _ref7.replace;

      if (!this.callFacetHandler('facetSelected', facet, key, bucket)) {
        key = this.callFacetHandler('facetKey', facet, key, bucket) || key;
        var router = this.getRouter();
        var q = new Query(router.currentRoute.query);

        if (replace) {
          q.replace(facet, key);
        } else {
          q.set(facet, key);
        }

        router.push({
          query: q.query
        });
      }
    }
  }, {
    key: "callFacetHandler",
    value: function callFacetHandler(methodName) {
      var _this$facetHandler;

      if (!this.facetHandler || !this.facetHandler[methodName]) {
        return null;
      }

      for (var _len3 = arguments.length, options = new Array(_len3 > 1 ? _len3 - 1 : 0), _key4 = 1; _key4 < _len3; _key4++) {
        options[_key4 - 1] = arguments[_key4];
      }

      return (_this$facetHandler = this.facetHandler)[methodName].apply(_this$facetHandler, options);
    }
  }, {
    key: "facetDeselected",
    value: async function facetDeselected(_ref8) {
      var facet = _ref8.facet,
          key = _ref8.key,
          bucket = _ref8.bucket;

      if (!this.callFacetHandler('facetDeselected', facet, key, bucket)) {
        key = this.callFacetHandler('facetKey', facet, key, bucket) || key;
        var router = this.getRouter();
        var q = new Query(router.currentRoute.query);
        q.remove(facet, key);
        router.push({
          query: q.query
        });
      }
    }
  }, {
    key: "restSearchUrl",
    get: function get() {
      var col = this.collectionDefinition;

      if (col && col.rest) {
        return col.rest;
      }

      return undefined;
    }
  }, {
    key: "loaded",
    get: function get() {
      return this.state === State.LOADED;
    }
  }]);

  return CollectionModule;
}(VuexModule), _temp2), (_applyDecoratedDescriptor(_class5.prototype, "setFacetHandler", [Mutation], Object.getOwnPropertyDescriptor(_class5.prototype, "setFacetHandler"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "setState", [Mutation], Object.getOwnPropertyDescriptor(_class5.prototype, "setState"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "setCollectionListModule", [Mutation], Object.getOwnPropertyDescriptor(_class5.prototype, "setCollectionListModule"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "setCollectionDefinition", [Mutation], Object.getOwnPropertyDescriptor(_class5.prototype, "setCollectionDefinition"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "setValueTranslator", [Mutation], Object.getOwnPropertyDescriptor(_class5.prototype, "setValueTranslator"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "setQueryParams", [Mutation], Object.getOwnPropertyDescriptor(_class5.prototype, "setQueryParams"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "setSearchResults", [Mutation], Object.getOwnPropertyDescriptor(_class5.prototype, "setSearchResults"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "search", [Action], Object.getOwnPropertyDescriptor(_class5.prototype, "search"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "changeLocale", [Action], Object.getOwnPropertyDescriptor(_class5.prototype, "changeLocale"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "setPage", [Action], Object.getOwnPropertyDescriptor(_class5.prototype, "setPage"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "facetSelected", [Action], Object.getOwnPropertyDescriptor(_class5.prototype, "facetSelected"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "facetDeselected", [Action], Object.getOwnPropertyDescriptor(_class5.prototype, "facetDeselected"), _class5.prototype)), _class5)) || _class4;

var CollectionItemModule = Module(_class7 = (_class8 = (_temp3 =
/*#__PURE__*/
function (_VuexModule3) {
  _inherits(CollectionItemModule, _VuexModule3);

  function CollectionItemModule() {
    var _getPrototypeOf4;

    var _this4;

    _classCallCheck(this, CollectionItemModule);

    for (var _len4 = arguments.length, args = new Array(_len4), _key5 = 0; _key5 < _len4; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this4 = _possibleConstructorReturn(this, (_getPrototypeOf4 = _getPrototypeOf(CollectionItemModule)).call.apply(_getPrototypeOf4, [this].concat(args)));
    _this4.collectionDefinition = {};
    _this4.valueTranslator = null;
    _this4.state = State.INVALID;
    _this4.item = {};
    _this4.itemId = null;
    _this4.collectionListModule = null;
    _this4.collectionModule = null;
    _this4.itemPreprocessors = [];
    return _this4;
  }

  _createClass(CollectionItemModule, [{
    key: "setCollectionListModule",
    value: function setCollectionListModule(collectionListModule) {
      this.collectionListModule = collectionListModule;
    }
  }, {
    key: "setCollectionModule",
    value: function setCollectionModule(collectionModule) {
      this.collectionModule = collectionModule;
    }
  }, {
    key: "setState",
    value: function setState(state) {
      this.state = state;
    }
  }, {
    key: "setCollectionDefinition",
    value: function setCollectionDefinition(collectionDefinition) {
      this.collectionDefinition = collectionDefinition;
    }
  }, {
    key: "setValueTranslator",
    value: function setValueTranslator(valueTranslator) {
      this.valueTranslator = valueTranslator;
    }
  }, {
    key: "setItem",
    value: function setItem(item) {
      this.item = item;
    }
  }, {
    key: "setItemId",
    value: function setItemId(itemId) {
      this.itemId = itemId;
    }
  }, {
    key: "registerItemPreprocessor",
    value: function registerItemPreprocessor(itemPreprocessor) {
      this.itemPreprocessors.push(itemPreprocessor);
    }
  }, {
    key: "unregisterItemPreprocessor",
    value: function unregisterItemPreprocessor(itemPreprocessor) {
      this.itemPreprocessors = this.itemPreprocessors.filter(function (x) {
        return x !== itemPreprocessor;
      });
    }
  }, {
    key: "load",
    value: async function load(_ref9) {
      var collectionDefinition = _ref9.collectionDefinition,
          itemId = _ref9.itemId,
          _ref9$force = _ref9.force,
          force = _ref9$force === void 0 ? false : _ref9$force;

      if (this.loaded && this.collectionDefinition.code === collectionDefinition.code && this.itemId === itemId && !force) {
        return {
          item: this.item // already loaded

        };
      }

      this.setCollectionDefinition(collectionDefinition);
      this.setItemId(itemId);
      this.setState(State.LOADING);
      var response = await axios.get(this.itemRestUrl);
      var item = response.data;
      this.itemPreprocessors.forEach(function (x) {
        return x(item, 'loaded');
      });
      this.setItem(item);
      this.setState(State.LOADED);
      return {
        item: response.data
      };
    }
  }, {
    key: "reload",
    value: async function reload() {
      this.load({
        collectionDefinition: this.collectionDefinition,
        itemId: this.itemId,
        force: true
      });
    }
  }, {
    key: "patch",
    value: async function patch(data) {
      if (!Array.isArray(data)) {
        data = [data];
      }

      var resp = await axios.patch(this.itemRestUrl, data, {
        headers: {
          'Content-Type': 'application/json-patch+json'
        }
      });

      if (resp.status === 200) {
        this.setItem(resp.data);
      }

      return resp;
    }
  }, {
    key: "restUrl",
    get: function get() {
      var col = this.collectionDefinition;

      if (col && col.rest) {
        return col.rest;
      }

      return undefined;
    }
  }, {
    key: "loaded",
    get: function get() {
      return this.state === State.LOADED;
    }
  }, {
    key: "itemRestUrl",
    get: function get() {
      return "".concat(this.restUrl).concat(this.itemId);
    }
  }]);

  return CollectionItemModule;
}(VuexModule), _temp3), (_applyDecoratedDescriptor(_class8.prototype, "setCollectionListModule", [Mutation], Object.getOwnPropertyDescriptor(_class8.prototype, "setCollectionListModule"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "setCollectionModule", [Mutation], Object.getOwnPropertyDescriptor(_class8.prototype, "setCollectionModule"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "setState", [Mutation], Object.getOwnPropertyDescriptor(_class8.prototype, "setState"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "setCollectionDefinition", [Mutation], Object.getOwnPropertyDescriptor(_class8.prototype, "setCollectionDefinition"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "setValueTranslator", [Mutation], Object.getOwnPropertyDescriptor(_class8.prototype, "setValueTranslator"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "setItem", [Mutation], Object.getOwnPropertyDescriptor(_class8.prototype, "setItem"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "setItemId", [Mutation], Object.getOwnPropertyDescriptor(_class8.prototype, "setItemId"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "registerItemPreprocessor", [Mutation], Object.getOwnPropertyDescriptor(_class8.prototype, "registerItemPreprocessor"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "unregisterItemPreprocessor", [Mutation], Object.getOwnPropertyDescriptor(_class8.prototype, "unregisterItemPreprocessor"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "load", [Action], Object.getOwnPropertyDescriptor(_class8.prototype, "load"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "reload", [Action], Object.getOwnPropertyDescriptor(_class8.prototype, "reload"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "patch", [Action], Object.getOwnPropertyDescriptor(_class8.prototype, "patch"), _class8.prototype)), _class8)) || _class7;

var InvalidDataException =
/*#__PURE__*/
function (_Error) {
  _inherits(InvalidDataException, _Error);

  function InvalidDataException(errors) {
    _classCallCheck(this, InvalidDataException);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidDataException).call(this, "Invalid input data at ".concat(errors)));
  }

  return InvalidDataException;
}(_wrapNativeSuper(Error));

var _dec$3, _dec2$1, _dec3$1, _dec4$1, _class$4, _class2$2, _temp$1;
var OARepoItem = (_dec$3 = Component({
  props: {
    collectionCode: String,
    itemId: String,
    locale: String,
    isolated: Boolean
  },
  components: {
    'oarepo-facet-list': OARepoFacetList$1
  },
  name: 'oarepo-item'
}), _dec2$1 = Emit('dataLoaded'), _dec3$1 = Watch('locale'), _dec4$1 = Watch('$route'), _dec$3(_class$4 = (_class2$2 = (_temp$1 =
/*#__PURE__*/
function (_Vue) {
  _inherits(OARepoItem, _Vue);

  function OARepoItem() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OARepoItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OARepoItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.activeEditors = [];
    _this.store = null;
    _this.collectionStore = null;
    _this.storeName = null;
    _this.collectionStoreName = null;
    return _this;
  }

  _createClass(OARepoItem, [{
    key: "mounted",
    value: function mounted() {
      if (this.isolated) {
        this.createIsolatedStore();
      } else {
        this.store = this.oarepo$.collectionItemModule;
      }

      this.reloadData();
    }
  }, {
    key: "createIsolatedStore",
    value: function createIsolatedStore() {
      var _this2 = this;

      this.storeName = "".concat(this.collectionCode).concat(this.itemId);
      this.collectionStoreName = "collection-".concat(this.collectionCode).concat(this.itemId);
      this.store = new CollectionItemModule({
        store: this.$store,
        name: this.storeName
      });
      this.collectionStore = new CollectionModule({
        store: this.$store,
        name: this.collectionStoreName
      });
      this.collectionStore.setCollectionListModule(this.oarepo$.collectionListModule);
      this.collectionStore.setCollectionDefinition(this.oarepo$.collectionListModule.collections.filter(function (x) {
        return x.code === _this2.collectionCode;
      })[0]);
      this.store.setCollectionListModule(this.oarepo$.collectionListModule);
      this.store.setCollectionModule(this.collectionStore);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.isolated) {
        this.$store.unregisterModule(this.storeName);
        this.$store.unregisterModule(this.collectionStoreName);
      }
    } // getters

  }, {
    key: "reloadData",
    value: function reloadData() {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3.store.collectionListModule.loadCollections().then(function () {
          _this3.store.load({
            collectionDefinition: _this3.collection,
            collectionCode: _this3.collectionCode,
            itemId: _this3.itemId
          }).then(function (_ref) {
            var append = _ref.append;
            resolve({
              append: append
            });
          });
        });
      });
    }
  }, {
    key: "onLocaleChanged",
    value: function onLocaleChanged(locale) {
      this.store.collectionModule.changeLocale(locale);
    }
  }, {
    key: "onQueryChanged",
    value: function onQueryChanged() {
      this.reloadData();
    } // modification operations

  }, {
    key: "patch",
    value: async function patch(data) {
      var _this4 = this;

      if (data === undefined) {
        // save all
        var statuses = await Promise.all(this.activeEditors.map(function (x) {
          return x.validate();
        }));

        if (statuses.filter(function (x) {
          return !x;
        }).length) {
          throw new InvalidDataException(statuses.map(function (x, idx) {
            return [_this4.activeEditors[idx].name, x];
          }).filter(function (x) {
            return !x[1];
          }).map(function (x) {
            return "".concat(x[0]);
          }).join(', '));
        }

        data = [];
        this.activeEditors.map(function (x) {
          return x.patchRepresentation();
        }).filter(function (x) {
          return x !== undefined && x != null;
        }).forEach(function (x) {
          var _data;

          (_data = data).push.apply(_data, _toConsumableArray(x));
        });
      }

      return this.store.patch(data);
    }
  }, {
    key: "registerEditor",
    value: function registerEditor(editor) {
      this.activeEditors.push(editor);
    }
  }, {
    key: "unregisterEditor",
    value: function unregisterEditor(editor) {
      this.activeEditors = this.activeEditors.filter(function (x) {
        return editor !== x;
      });
    }
  }, {
    key: "loaded",
    get: function get() {
      return this.store && this.store.loaded;
    }
  }, {
    key: "collection",
    get: function get() {
      var _this5 = this;

      return this.store.collectionListModule.collections.find(function (value) {
        return value.code === _this5.collectionCode;
      });
    }
  }, {
    key: "item",
    get: function get() {
      return this.store.item;
    }
  }]);

  return OARepoItem;
}(Vue), _temp$1), (_applyDecoratedDescriptor(_class2$2.prototype, "reloadData", [_dec2$1], Object.getOwnPropertyDescriptor(_class2$2.prototype, "reloadData"), _class2$2.prototype), _applyDecoratedDescriptor(_class2$2.prototype, "onLocaleChanged", [_dec3$1], Object.getOwnPropertyDescriptor(_class2$2.prototype, "onLocaleChanged"), _class2$2.prototype), _applyDecoratedDescriptor(_class2$2.prototype, "onQueryChanged", [_dec4$1], Object.getOwnPropertyDescriptor(_class2$2.prototype, "onQueryChanged"), _class2$2.prototype)), _class2$2)) || _class$4);

/* script */
var __vue_script__$3 = OARepoItem;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.loaded ? _c('div', {
    staticClass: "container"
  }, [_vm.item && _vm.item.metadata ? [_vm._t("default", [_c('router-view')], {
    "collection": _vm.collection,
    "item": _vm.item
  })] : _vm._e()], 2) : _vm._e();
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

var OARepoItem$1 = __vue_normalize__({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, undefined, undefined);

var OARepo = {
  install: function install(Vue, _ref) {
    var store = _ref.store,
        valueTranslator = _ref.valueTranslator,
        apiURL = _ref.apiURL,
        facetHandler = _ref.facetHandler,
        itemPreprocessors = _ref.itemPreprocessors;
    Vue.component('oarepo-collection-list', OARepoCollectionList$1);
    Vue.component('oarepo-collection', OARepoCollection$1);
    Vue.component('oarepo-item', OARepoItem$1);
    Vue.component('oarepo-facet-list', OARepoFacetList$1);
    var oarepo$ = {
      collectionListModule: new CollectionListModule({
        store: store,
        name: 'collections'
      }),
      collectionModule: new CollectionModule({
        store: store,
        name: 'collection'
      }),
      collectionItemModule: new CollectionItemModule({
        store: store,
        name: 'collectionItem'
      })
    };
    oarepo$.collectionListModule.setApiURL(apiURL);
    oarepo$.collectionModule.setCollectionListModule(oarepo$.collectionListModule);
    oarepo$.collectionItemModule.setCollectionListModule(oarepo$.collectionListModule);
    oarepo$.collectionItemModule.setCollectionModule(oarepo$.collectionModule);
    oarepo$.collectionModule.setValueTranslator(valueTranslator);
    oarepo$.collectionModule.setFacetHandler(facetHandler); // setTimeout(() => { oarepo$.collectionModule.setRouter(router); }, 1000);

    if (itemPreprocessors !== undefined) {
      itemPreprocessors.forEach(function (x) {
        oarepo$.collectionItemModule.registerItemPreprocessor(x);
      });
    }

    Vue.prototype.oarepo$ = oarepo$;
  }
}; // Export components individually

export { CollectionItemModule, CollectionListModule, CollectionModule, InvalidDataException, OARepo, OARepoCollection$1 as OARepoCollection, OARepoCollectionList$1 as OARepoCollectionList, OARepoFacetList$1 as OARepoFacetList, OARepoItem$1 as OARepoItem, Query };
